import { combineReducers } from 'redux';

import transactions from './receipt';

const reducer = combineReducers({
  [transactions.name]: transactions.reducer,
});

export default reducer;
